import { GetCustomerCopyFunc } from '@lyrahealth-inc/shared-app-logic'

export const servicenow: GetCustomerCopyFunc = () => {
  return {
    displaySessionLimit: false,
  }
}
